import giftApi from '../apis/gift'
import format from 'date-fns/format'
import { ShipPayMethods, GIFT_TYPE } from '@/tools/constant'
import { createDefaultGiftShipWay } from '@/tools/shipFee'

const state = {
  giftList: {
    maxGiftId: '',
    currentPage: 0,
    nextPageUrl: 'http://',
    data: [],
    total: 0,
    lastPage: 1,
    loading: false,
    mode: 'col' // 'row' or 'col'
  },
  giftListTaipei: {
    curIdx: 0,
    currentPage: 0,
    nextPageUrl: 'http://',
    data: []
  },
  newGifts: [{
    isSpread: true,
    imgLists: [],
    isImgLoaded: false,
    title: '',
    titleLength: 0,
    category_id: '',
    category_label: [],
    item_category_id: '',
    item_category_label: [],
    valuation_id: '',
    valuation_label: [],
    isNew: '',
    quantity: 1,
    desc: '',
    type: GIFT_TYPE.NORMAL
  }],
  newGiftsShareInfo: {
    address: '',
    city: '',
    district: '',
    orgFirst: 0,
    bank1: ['無'],
    bank2: ['無'],
    date: '', // 刊登日期
    prior: 1,
    give543Day1122: false,
    shipWay: createDefaultGiftShipWay()
  },
  newGift: {
    imgLists: [],
    quantity: 1,
    category_label: [],
    valuation_label: [],
    title: '',
    desc: '',
    isNew: '',
    address: '',
    city: '',
    district: '',
    gift_images: [],
    gift_ships: [],
    orgFirst: 0,
    bank1: ['無'],
    bank2: ['無'],
    date: '', // 刊登日期
    prior: 1,
    shipWay: createDefaultGiftShipWay()
  },
  requestGift: {
    pics: []
  },
  currentGift: {
    gift_images: [],
    user: {},
    show_at: ''
  },
  currentGiftEdited: false,
  recruitScrollY: '',
  cabinetBanners: [],
  homeGiftList: [],
  cabinetGiftList: {
    currentPage: 1,
    nextPageUrl: 'http://',
    data: []
  },
  confirmShipInfo: {
    id: null,
    shipway: '',
    shipfee: '',
    shipopts: '',
    giverName: '',
    giverPhone: '',
    giverCity: '',
    giverDistrict: '',
    giverAddress: '',
    payMethod: ShipPayMethods.OFFLINE,
    gifts: []
  },
  sendGiftInfo: {
    id: null,
    max: '',
    shipway: '',
    shipfee: '',
    pic: '',
    name: '',
    shipopts: '',
    payMethod: '',
    directUserName: '',
    left: 0,
    city: '',
    district: '',
    address: ''
  },
  flashGiftList: {
    data: [],
    currentPage: 0,
    lastPage: 1,
    loading: false,
    total: 0,
    randomSeed: new Date().getTime(),
    maxGiftId: '',
    mode: 'col'
  },
  brandGiftList: {
    data: [],
    currentPage: 0,
    lastPage: 1,
    loading: false,
    total: 0,
    randomSeed: new Date().getTime(),
    maxGiftId: '',
    mode: 'col'
  },
  dormGiftList: {
    data: [],
    currentPage: 0,
    lastPage: 1,
    loading: false,
    total: 0,
    randomSeed: new Date().getTime(),
    maxGiftId: ''
  },
  currentTabIndex: -1
}

const actions = {
  getCurrentGift ({commit, state}, {giftId}) {
    giftApi.getItemData(
      giftId,
      (data) => commit('setCurrentGift', {data})
    )
  },
  /**
   * @param commit
   * @param state
   * @param page
   * @param onPool
   * @param isNew
   * @param orgFirst
   * @param sort
   * @param category
   * @param isSearch
   * @param bureauId
   * @param cb
   * @param isClear
   * @param type 2为名柜好礼
   * @param perPage 每页多少个数
   * @param status ongoing进行中 finish索取完 end结案
   * @param refresh 每次请求刷新vuex数据
   * @param home 首页展示
   * @param noRequestList 没有索取者的信息，在后面加上/home
   */
  getGiftList ({commit, state}, {page = '', onPool = '', isNew = '',
    orgFirst = '', ongoing = '', sort = '', category = '', isSearch = '',
    bureauId = '', cb = null, isClear = false, type = '', perPage = '', status = '',
    refresh = false, home = false, noRequestList = false, maxGiftId = '',
    randomSeed = '', isTraceUser = '', shipway = '', video = ''} = {}) {
    giftApi.getGiftList(
      page,
      onPool,
      isNew,
      orgFirst,
      ongoing,
      sort,
      category,
      bureauId,
      type,
      perPage,
      status,
      noRequestList,
      maxGiftId,
      randomSeed,
      isTraceUser,
      shipway,
      video,
      (data) => {
        if (isClear && bureauId) {
          commit('resetGiftListTaipei')
        } else if (isClear) {
          commit('resetGiftList')
        }

        if (data && !data.error) {
          if (bureauId) {
            commit('setGiftListTaipei', {data})
          } else {
            if (home) {
              commit('setHomeGiftList', {data})
            } else {
              if (type === 2) {
                // 名柜好礼
                commit('setCabinetGiftList', {isSearch, data, refresh})
              } else {
                commit('setGiftList', {isSearch, data, refresh})
              }
            }
          }
        }
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getGiftInfo ({commit, state}, {id, cb = null} = {}) {
    giftApi.getGiftInfo(
      id,
      (data) => {
        if (data && !data.error) {
          commit('setCurrentGift', {data})
        }
        if (cb) {
          cb(data)
        }
      }
    )
  },
  giftsRequest ({commit, state}, {data, cb}) {
    giftApi.giftsRequest(
      data,
      (data) => cb(data)
    )
  },
  publishGift ({commit, state}, {data, cb}) {
    giftApi.publishGift(
      data,
      (data) => {
        if (data && !data.error) {
          commit('addNewGift', data)
        }
        cb(data)
      }
    )
  },
  editGift ({commit, state}, {data, id}) {
    return giftApi.editGift(data, id)
      .then(res => {
        commit('setCurrentGift', {
          data: {
            ...data,
            ...res
          }
        })
        commit('setCurrentGiftEdited', {edited: true})
        return res
      })
  },
  getCabinetBanners ({commit, state}) {
    giftApi.getCabinetBanners(
      (data) => commit('setCabinetBanners', {data})
    )
  },
  getTypeGiftList ({ commit, state }, { page = '', onPool = '', isNew = '',
    orgFirst = '', ongoing = '', sort = '', category = '', isSearch = '',
    bureauId = '', cb = null, isClear = false, type = '', perPage = '', status = '',
    refresh = false, home = false, noRequestList = false, maxGiftId = '',
    randomSeed = '', isTraceUser = '', shipway = '', video = '',
    includeBrand = '' } = {}) {
    commit('setTypeGiftListLoading', { type, loading: true })
    return giftApi.getGiftList(
      page,
      onPool,
      isNew,
      orgFirst,
      ongoing,
      sort,
      category,
      bureauId,
      type,
      perPage,
      status,
      noRequestList,
      maxGiftId,
      randomSeed,
      isTraceUser,
      shipway,
      video,
      includeBrand
    ).then((data) => {
      commit('setTypeGiftList', { type, data })
      return data
    }).catch((err) => {
      commit('setTypeGiftListLoading', { type, loading: false })
      throw err
    })
  }
}

const mutations = {
  setCurrentGift (state, {data}) {
    state.currentGift = {
      ...state.currentGift,
      ...data
    }
  },
  setCurrentGiftEdited (state, {edited}) {
    state.currentGiftEdited = edited
  },
  setGiftList (state, {isSearch, data, refresh}) {
    if (isSearch && data.current_page === 1) {
      state.giftList.data = []
    }
    if (data.current_page === 1) {
      state.giftList.maxGiftId = data.maxGiftId
    }
    let stateList = refresh ? [] : state.giftList.data
    state.giftList = {
      ...state.giftList,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: [
        ...stateList,
        ...data.data
      ]
    }
  },
  setCabinetGiftList (state, {isSearch, data, refresh}) {
    if (isSearch && data.current_page === 1) {
      state.cabinetGiftList.data = []
    }
    let stateList = refresh ? [] : state.cabinetGiftList.data
    state.cabinetGiftList = {
      ...state.cabinetGiftList,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: [
        ...stateList,
        ...data.data
      ]
    }
  },
  setHomeGiftList (state, {data}) {
    if (data) {
      state.homeGiftList = data.data
    }
  },
  resetGiftList (state) {
    state.giftList = {
      mode: state.giftList.mode,
      maxGiftId: '',
      currentPage: 0,
      nextPageUrl: 'http://',
      data: [],
      total: 0,
      lastPage: 1,
      loading: false
    }
  },
  setGiftListTaipei (state, {data}) {
    state.giftListTaipei = {
      ...state.giftListTaipei,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: [
        ...state.giftListTaipei.data,
        ...data.data
      ]
    }
  },
  resetGiftListTaipei (state) {
    state.giftListTaipei = {
      curIdx: 0,
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }
  },
  addNewGiveItem (state, type) {
    state.newGifts = [
      ...state.newGifts,
      {
        isSpread: true,
        imgLists: [],
        isImgLoaded: false,
        title: '',
        titleLength: 0,
        category_id: '',
        category_label: [],
        item_category_id: '',
        item_category_label: [],
        valuation_label: [],
        isNew: '',
        quantity: 1,
        desc: '',
        type
      }
    ]
  },
  removeGiveItem (state, payload) {
    state.newGifts = payload
  },
  setGiveItem (state, {index, giveItem}) {
    let giveItems = Object.assign([], state.newGifts)
    giveItems[index] = {
      ...state.newGifts[index],
      ...giveItem
    }
    state.newGifts = giveItems
  },
  setGivesShareInfo (state, payload) {
    state.newGiftsShareInfo = {
      ...state.newGiftsShareInfo,
      ...payload
    }
  },
  setGivesMeetInfo (state, { city, district, address }) {
    state.newGiftsShareInfo = {
      ...state.newGiftsShareInfo,
      shipWay: createDefaultGiftShipWay()
    }
  },
  // 上傳成功後清空刊登禮物的暫存資料
  resetNewGift (state, type) {
    state.newGifts = [{
      isSpread: true,
      imgLists: [],
      isImgLoaded: false,
      title: '',
      titleLength: 0,
      category_id: '',
      category_label: [],
      item_category_id: '',
      item_category_label: [],
      valuation_id: '',
      valuation_label: [],
      isNew: '',
      quantity: 1,
      desc: '',
      type: type || GIFT_TYPE.NORMAL
    }]
    state.newGiftsShareInfo = {
      address: '',
      city: '',
      district: '',
      orgFirst: 0,
      bank1: ['無'],
      bank2: ['無'],
      date: format(new Date(), 'YYYY/MM/DD'), // 刊登日期
      prior: 1,
      give543Day1122: false,
      shipWay: createDefaultGiftShipWay()
    }
  },
  setReqGiftPics (state, {data}) {
    state.requestGift.pics = [
      ...state.requestGift.pics,
      data
    ]
  },
  deleteReqGiftPic (state, {i}) {
    state.requestGift.pics = state.requestGift.pics.filter((item, index) => i !== index)
  },
  changeRecruitScrollY (state, { data }) {
    state.recruitScrollY = data
  },
  setCabinetBanners (state, { data }) {
    state.cabinetBanners = data
  },
  changeCurrentGiftsMode (state, { mode }) {
    state.giftList.mode = mode
    state.flashGiftList.mode = mode
  },
  setGiftRequestConfirmShipInfo (state, payload) {
    state.confirmShipInfo = payload
  },
  setGiftRequestSendGiftInfo (state, payload) {
    state.sendGiftInfo = payload
  },
  setTypeGiftList (state, { type, data }) {
    if (type === GIFT_TYPE.NORMAL) {
      if (data.current_page === 1) {
        state.giftList.maxGiftId = data.maxGiftId
      }
      state.giftList = {
        ...state.giftList,
        currentPage: data.current_page,
        lastPage: data.last_page,
        nextPageUrl: data.next_page_url,
        total: data.total,
        data: data.current_page === 1 ? data.data : [...state.giftList.data, ...data.data],
        loading: false
      }
    } else if (type === GIFT_TYPE.FLASH) {
      if (data.current_page === 1) {
        state.flashGiftList.maxGiftId = data.maxGiftId
      }
      state.flashGiftList = {
        ...state.flashGiftList,
        currentPage: data.current_page,
        lastPage: data.last_page,
        nextPageUrl: data.next_page_url,
        total: data.total,
        data: data.current_page === 1 ? data.data : [...state.flashGiftList.data, ...data.data],
        loading: false
      }
    } else if (type === GIFT_TYPE.BRAND) {
      if (data.current_page === 1) {
        state.brandGiftList.maxGiftId = data.maxGiftId
      }
      state.brandGiftList = {
        ...state.brandGiftList,
        currentPage: data.current_page,
        lastPage: data.last_page,
        nextPageUrl: data.next_page_url,
        total: data.total,
        data: data.current_page === 1 ? data.data : [...state.brandGiftList.data, ...data.data],
        loading: false
      }
    } else if (type === GIFT_TYPE.DORM) {
      if (data.current_page === 1) {
        state.dormGiftList.maxGiftId = data.maxGiftId
      }
      state.dormGiftList = {
        ...state.dormGiftList,
        currentPage: data.current_page,
        lastPage: data.last_page,
        nextPageUrl: data.next_page_url,
        total: data.total,
        data: data.current_page === 1 ? data.data : [...state.dormGiftList.data, ...data.data],
        loading: false
      }
    }
  },
  setTypeGiftListLoading (state, { type, loading }) {
    if (type === GIFT_TYPE.NORMAL) {
      state.giftList.loading = loading
    } else if (type === GIFT_TYPE.FLASH) {
      state.flashGiftList.loading = loading
    } else if (type === GIFT_TYPE.BRAND) {
      state.brandGiftList.loading = loading
    } else if (type === GIFT_TYPE.DORM) {
      state.dormGiftList.loading = loading
    }
  },
  setTypeGiftRandomSeed (state, { type, randomSeed }) {
    if (type === GIFT_TYPE.FLASH) {
      state.flashGiftList.randomSeed = randomSeed
    } else if (type === GIFT_TYPE.BRAND) {
      state.brandGiftList.randomSeed = randomSeed
    } else if (type === GIFT_TYPE.DORM) {
      state.dormGiftList.randomSeed = randomSeed
    }
  },
  resetTypeGiftList (state, { type }) {
    if (type === GIFT_TYPE.NORMAL) {
      state.giftList = {
        ...state.giftList,
        maxGiftId: '',
        currentPage: 0,
        nextPageUrl: 'http://',
        data: [],
        total: 0,
        lastPage: 1,
        loading: false
      }
    } else if (type === GIFT_TYPE.FLASH) {
      state.flashGiftList = {
        ...state.flashGiftList,
        data: [],
        currentPage: 0,
        lastPage: 1,
        loading: false,
        total: 0,
        randomSeed: new Date().getTime(),
        maxGiftId: ''
      }
    } else if (type === GIFT_TYPE.BRAND) {
      state.brandGiftList = {
        ...state.brandGiftList,
        data: [],
        currentPage: 0,
        lastPage: 1,
        loading: false,
        total: 0,
        randomSeed: new Date().getTime(),
        maxGiftId: ''
      }
    } else if (type === GIFT_TYPE.DORM) {
      state.dormGiftList = {
        data: [],
        currentPage: 0,
        lastPage: 1,
        loading: false,
        total: 0,
        randomSeed: new Date().getTime(),
        maxGiftId: ''
      }
    }
  },
  addNewGift (state, data) {
    if (data.status !== 'ongoing') {
      return
    }
    if (data.type === GIFT_TYPE.FLASH) {
      state.flashGiftList.data.unshift(data)
      state.flashGiftList.total += 1
    } else if (data.type === GIFT_TYPE.BRAND) {
      state.brandGiftList.data.unshift(data)
      state.brandGiftList.total += 1
    } else if (data.type === GIFT_TYPE.DORM) {
      state.dormGiftList.data.unshift(data)
      state.dormGiftList.total += 1
    } else {
      state.giftList.data.unshift(data)
    }
  },
  setCurrentTabIndex (state, {index}) {
    state.currentTabIndex = index
  }
}

export default{
  state,
  actions,
  mutations
}
